import { decode } from "@clockwise/web-commons/src/util/eventKeyEncoding";
import { FOCUSED_EVENT_ID } from "../../constants";

export const getActiveEventKeyFromStorage = (storage: Storage) => {
  const stored = storage.getItem(FOCUSED_EVENT_ID);
  if (!stored) return null;

  const decoded = decode(stored);
  if (!decoded) return null;

  return decoded;
};
